import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const bnBdTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'নাম (ছোট হাতের, বিশেষ অক্ষর নেই)',
    add: 'যোগ করুন',
    allowedFileTypes: 'অনুমোদিত ফাইল প্রকার',
    allowedFileTypesDescription:
      'অনুমোদিত ফাইল প্রকারগুলি সীমাবদ্ধ করুন (যেমন, চিত্র/*, অ্যাপ্লিকেশন/পিডিএফ)। সব ধরনের অনুমতি দিতে খালি ছেড়ে দিন।',
    allowMultipleFiles: 'একাধিক ফাইলের অনুমতি দিন',
    amountInCents: 'সেন্টে পরিমাণ',
    basePrice: 'বেস প্রাইস',
    bcc: 'বিসিসি',
    brand: 'ব্র্যান্ড',
    cc: 'সিসি',
    checkboxPlural: 'চেকবক্স ক্ষেত্র',
    checkboxSingular: 'চেকবক্স',
    checkedByDefault: 'ডিফল্টরূপে চেক করা হয়েছে',
    chooseConfirmationType:
      'তারা ফর্ম জমা দেওয়ার পরে একটি অন-পৃষ্ঠা বার্তা প্রদর্শন করবেন বা অন্য পৃষ্ঠায় পুনঃনির্দেশ করবেন কিনা তা চয়ন করুন৷',
    condition: 'অবস্থা',
    confirmationMessage: 'নিশ্চিতকরণ বার্তা',
    confirmationType: 'নিশ্চিতকরণ প্রকার',
    countryPlural: 'দেশের মাঠ',
    countrySingular: 'দেশ',
    creditCard: 'ক্রেডিট কার্ড',
    customURL: 'কাস্টম URL',
    datePlural: 'তারিখ ক্ষেত্র',
    dateSingular: 'তারিখ',
    defaultValue: 'ডিফল্ট মান',
    divide: 'ভাগ করুন',
    documentToLinkTo: 'লিঙ্ক করার জন্য নথি',
    doesNotEqual: 'সমান নয়',
    emailFrom: 'থেকে ইমেল',
    emailPlural: 'ইমেল ক্ষেত্র',
    emailsDescription:
      'ফর্ম জমা হলে কাস্টম ইমেল পাঠান. একাধিক প্রাপককে একই ইমেল পাঠাতে কমা বিভক্ত তালিকা ব্যবহার করুন। এই ফর্ম থেকে একটি মান উল্লেখ করতে, সেই ক্ষেত্রের নাম ডবল কোঁকড়া বন্ধনী দিয়ে মোড়ানো, যেমন {{firstName}}। আপনি একটি ওয়াইল্ডকার্ড ব্যবহার করতে পারেন {{*}} সমস্ত ডেটা আউটপুট করতে এবং {{*:table}} এটিকে ইমেলে একটি HTML টেবিল হিসাবে ফর্ম্যাট করতে।',
    emailSingular: 'ইমেইল',
    emailTo: 'ইমেইল করুন',
    equals: 'সমান',
    field: 'মাঠ',
    fields: 'ক্ষেত্র',
    fieldWidth: 'ক্ষেত্রের প্রস্থ (শতাংশ)',
    hasAnyValue: 'কোন মান আছে',
    internalLink: 'অভ্যন্তরীণ লিঙ্ক',
    label: 'লেবেল',
    maxFileSize: 'সর্বোচ্চ ফাইলের আকার (বাইট)',
    maxFileSizeDescription: 'বাইটে সর্বোচ্চ ফাইলের আকার। কোন সীমা জন্য খালি ছেড়ে দিন.',
    message: 'বার্তা',
    messageDescription: 'এই ইমেলে যে বার্তাটি পাঠানো উচিত তা লিখুন।',
    messagePlural: 'বার্তা ব্লক',
    messageSingular: 'বার্তা',
    mimeType: 'MIME প্রকার',
    mimeTypePlural: 'MIME প্রকার',
    mimeTypeSingular: 'MIME প্রকার',
    multiply: 'গুন করুন',
    numberPlural: 'সংখ্যা ক্ষেত্র',
    numberSingular: 'সংখ্যা',
    optionPlural: 'অপশন',
    optionSingular: 'অপশন',
    paymentFieldPlural: 'পেমেন্ট ক্ষেত্র',
    paymentFieldSingular: 'পেমেন্ট',
    paymentProcessor: 'পেমেন্ট প্রসেসর',
    paymentStatus: 'স্ট্যাটাস',
    placeholder: 'স্থানধারক',
    priceConditions: 'মূল্য শর্তাবলী',
    priceConditionsPlural: 'মূল্য শর্তাবলী',
    priceConditionsSingular: 'মূল্য শর্ত',
    radioOptions: 'রেডিও বৈশিষ্ট্য বিকল্প',
    radioPlural: 'রেডিও ক্ষেত্র',
    radioSingular: 'রেডিও',
    redirect: 'পুনঃনির্দেশ',
    replyTo: 'উত্তর দিন',
    required: 'প্রয়োজন',
    selectOptions: 'বিকল্প নির্বাচন করুন',
    selectPlural: 'ক্ষেত্র নির্বাচন করুন',
    selectSingular: 'নির্বাচন করুন',
    statePlural: 'রাষ্ট্রীয় ক্ষেত্র',
    stateSingular: 'রাজ্য',
    staticValue: 'স্ট্যাটিক মান',
    subject: 'বিষয়',
    submitButton: 'বোতাম লেবেল জমা দিন',
    subtract: 'বিয়োগ করুন',
    textareaPlural: 'Textarea ক্ষেত্র',
    textareaSingular: 'Textarea',
    textPlural: 'পাঠ্য ক্ষেত্র',
    textSingular: 'পাঠ্য',
    title: 'শিরোনাম',
    token: 'টোকেন',
    uploadCollection: 'সংগ্রহ আপলোড করুন',
    uploadCollectionDescription: 'ফাইলগুলি সংরক্ষণ করতে কোন আপলোড সংগ্রহ নির্বাচন করুন৷',
    uploadFieldPlural: 'আপলোড ক্ষেত্র',
    uploadFieldSingular: 'আপলোড করুন',
    urlToRedirectTo: 'রিডাইরেক্ট করার জন্য URL',
    value: 'মান',
    valueOfField: 'ক্ষেত্রের মান',
    valueType: 'মান প্রকার',
  },
}

export const bnBd: PluginLanguage = {
  dateFNSKey: 'bn-BD',
  translations: bnBdTranslations,
}
